import { SimpleField } from "../../../../components/fields/simpleField.jsx";
import React from "react";

export function InfoTab({ control }) {
  return (
    <div className={"flex flex-col gap-3 bg-white p-3"}>
      <div className={"flex gap-3"}>
        <div className={"flex-grow"}>
          <SimpleField
            label="amount"
            name={"amount"}
            control={control}
            type={"number"}
          />
        </div>
        <SimpleField
          label="currency"
          name={"currency"}
          control={control}
          type={"text"}
        />
      </div>
      <SimpleField label="date" name={"date"} control={control} type={"date"} />
      <SimpleField
        label="reference"
        name={"reference"}
        control={control}
        type={"text"}
      />
      <SimpleField
        label="counterpart"
        name={"counterpart"}
        type={"text"}
        control={control}
      />
      <SimpleField
        label="description"
        name={"description"}
        type={"textarea"}
        control={control}
      />
    </div>
  );
}
